import React from 'react'
import VideosListContent from './VideosListContent'
import VideosListIcon from './VideoListIcon'

const VideosListMenu = props => {
  return (
    <div className='videos-list-container'>
      <div className='entry-hover'>
        <VideosListIcon type={props.type} />
      </div>
      <div className='entries-list vjs-menu'>
        <VideosListContent {...props} />
      </div>
    </div>
  )
}

export default VideosListMenu
